import { InjectionToken } from '@angular/core';

export interface SplashScreenOptions {
  /**
   * Route URL prefixes whose navigation should NOT remove the splash
   * (e.g. an OIDC redirect callback that navigates before the real first view).
   * Defaults to an empty list.
   */
  transientRoutes?: string[];
}

export const SPLASH_SCREEN_OPTIONS = new InjectionToken<Required<SplashScreenOptions>>('SPLASH_SCREEN_OPTIONS');
